import { cva } from 'class-variance-authority';

// Shared styling for pill components
export const pillStylesBase = {
  // Container styles for pill collections
  container: 'flex flex-wrap items-center gap-2',

  // Remove button styles
  removeButton:
    'flex items-center justify-center w-4 h-4 rounded-full hover:bg-muted',

  // Icon styles
  removeIcon: 'w-3 h-3',
};
// CVA variant for pill styles
export const pillVariants = cva(
  'flex items-center gap-1 px-2 py-1 text-sm bg-secondary text-secondary-foreground rounded-full group',
  {
    variants: {
      variant: {
        default: 'cursor-default',
        clickable: 'cursor-pointer',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
